<template>
    <transition name="fade">
        <div class="popup" id="popup_thank_choosing_new" @click="$store.commit('openShareModal', false)">
            <div class="popup_block" @click.stop>
                <div class="close" @click="$store.commit('openShareModal', false)"></div>
                <div class="title_popup">
                    Share for download
                </div>
                <div class="pos_relative share-buttons">
                    <ul>
                        <li>
                            <fb-share v-model="is_success"></fb-share>
                        </li>
                        <!--<li>-->
                        <!--<vk-share v-model="is_success"></vk-share>-->
                        <!--</li>-->
                    </ul>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import cvDownloadMix from "../../mixins/cvDownload";
    import fbShare from "../share/facebook.vue";
    import vkShare from "../share/vk.vue";

    export default {
        data() {
            return {
                is_success: false
            };
        },
        components: {
            fbShare,
            vkShare
        },
        mixins: [
            cvDownloadMix
        ],
        props: {
            type: {
                type: String,
                required: true
            }
        },
        methods: {},
        watch: {
            is_success(new_value) {
                if (new_value) {
                    this.activateUserStatusBasic(this.$store.getters.openShareModal.type);
                }
            }
        }
    };
</script>

<style>
    .share-buttons img{
        width: 60px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/modals/open-share-modal.vue